import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createBlogCategory } from "../../api/apiBlogCategories";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء تصنيف جديد
 */
export function useCreateBlogCategory() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createBlogCategoryMutate,
        isPending,
    } = useMutation({
        mutationFn: createBlogCategory,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-categories"] });
            navigate('/blog/categories');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create blog category");
        },
    });

    return {
        createBlogCategoryMutate,
        isPending,
    };
}
